import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7e364fec"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CustomerBasket = _resolveComponent("CustomerBasket");

  var _component_CustomerSeatingChart = _resolveComponent("CustomerSeatingChart");

  return _openBlock(), _createElementBlock("div", {
    class: "customer-display",
    style: _normalizeStyle({
      backgroundImage: _ctx.pictureUrl ? "url(".concat(_ctx.pictureUrl, ")") : 'none'
    })
  }, [!_ctx.isUserLoggedIn ? (_openBlock(), _createElementBlock("div", _hoisted_1, "User is not logged in, screen is sleeping")) : _createCommentVNode("", true), _ctx.basketData ? (_openBlock(), _createBlock(_component_CustomerBasket, {
    key: _ctx.componentBasketKey,
    basketData: _ctx.basketData,
    ref: "customerBasket"
  }, null, 8, ["basketData"])) : _createCommentVNode("", true), _ctx.renderCustomerSeatingChart ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_CustomerSeatingChart, {
    chartData: _ctx.chartData,
    ref: "customerSeatingChart"
  }, null, 8, ["chartData"])])) : _createCommentVNode("", true)], 4);
}